// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { guff } from 'bam-node-baseball-savant/utils/guff'
import {
    mapPercentileNames,
    threeDigitTypes,
    pitchingRunTypes,
    guffTypes,
} from 'bam-node-baseball-savant/apps/utils/possible-comp-tool-stats.ts'
import { ValueElementProps } from './utils/types.ts'
import { RECT_HEIGHT, VALUE_FONT_SIZE, VALUE_WIDTH } from './utils/constants.ts'
import { useMode } from './utils/mode.tsx'

function ValueElement(props: ValueElementProps) {
    const {
        value,
        type,
        isNarrow,
        maxSliderWidth,
        fill,
        boldWinner,
        isUnqualified,
        isFake,
        playerId,
    } = props

    const mode = useMode()

    const guffType = mapPercentileNames(type)
    const isValueNull = value === null

    let guffedVal = String(value)

    if (
        threeDigitTypes.includes(guffType) ||
        pitchingRunTypes.includes(guffType) ||
        guffTypes.includes(guffType)
    ) {
        guffedVal = guff(Number(value), guffType)
    }

    if (isValueNull) {
        guffedVal = ''
    }

    return !isNarrow ? (
        <text
            x={0}
            y={(RECT_HEIGHT - VALUE_FONT_SIZE) / 2 + 2}
            className="label-value-number"
            textAnchor="end"
            dominantBaseline="hanging"
            fill="#666666"
            fontSize="9"
            fontWeight={boldWinner ? 'bold' : 'normal'}
        >
            {guffedVal}
        </text>
    ) : (
        <>
            <rect
                x={0}
                y={0}
                width={maxSliderWidth}
                height={RECT_HEIGHT}
                stroke={fill}
                strokeWidth={isValueNull ? 0 : 2}
                fill={
                    isUnqualified || isFake
                        ? `url(#${mode}-diagonal-hatch-${playerId}-${type})`
                        : fill
                }
            />

            {isFake ? (
                <rect
                    x={maxSliderWidth / 2 - VALUE_WIDTH / 2}
                    y={2}
                    width={VALUE_WIDTH}
                    height={RECT_HEIGHT - 4}
                    fill={fill}
                />
            ) : null}

            <text
                x={maxSliderWidth / 2}
                y={RECT_HEIGHT / 2}
                className="label-value-number-big"
                textAnchor="middle"
                dominantBaseline="central"
                fill="white"
                fontWeight="bold"
                fontSize="9"
            >
                {guffedVal}
            </text>
        </>
    )
}

export default ValueElement
